<template>
  <li class="single-cart">
    <div class="cart-info">
      <div class="cart-img">
        <router-link :to="{ name: 'product', params: { itemID: cartItem.itemID, WarehouseID: cartItem.item.WarehouseID }}">
          <img
          :src="getImageURL()"
          :alt="cartItem.item.ItemID"
          height="80px"
          width="80px"
          >
        </router-link>
      </div>
      <button
      class="cart-remove"
      title="Remove">
        <i
        class="ion-ios-close-empty"
        @click="removeCartItem()"
        />
      </button>
      <router-link :to="{ name: 'product', params: { itemID: cartItem.itemID, WarehouseID: cartItem.item.WarehouseID }}">
        {{ cartItem.itemDescription }}
      </router-link>
      <p class="cart-quantity"><strong>Aantal:</strong> {{ cartItem.amount }}</p>
    </div>
  </li>
</template>

<script>
import CartService from '@/services/CartService.js'

export default {
    props: {
        cartItem: {
            type: Object,
            required: true
        }
    },
    methods: {
        async removeCartItem () {
            let cartItemID = this.cartItem.cartItemID
            CartService.removeCartItem(cartItemID)
        },
        getImageURL () {
            return CartService.getImageURL(this.cartItem.item)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Cart/CartDropdownItem.vue